// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roster-fullview-toggle {
  background: none;
  border: none;
  padding: 0 6px 0 0;
  cursor: pointer;
  color: #676a6c;
  font-size: 13px;
  line-height: 1;
  vertical-align: middle;
}
.roster-fullview-toggle:hover {
  color: #23527c;
}`, "",{"version":3,"sources":["webpack://./src/app/components/org-individual-teams/roster-toolbar/roster-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AACF;AACE;EACE,cAAA;AACJ","sourcesContent":[".roster-fullview-toggle {\n  background: none;\n  border: none;\n  padding: 0 6px 0 0;\n  cursor: pointer;\n  color: #676a6c;\n  font-size: 13px;\n  line-height: 1;\n  vertical-align: middle;\n\n  &:hover {\n    color: #23527c;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
